import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/refresh.svg'


const _withScopeId = n => (_pushScopeId("data-v-f0f76aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-card-back-container" }
const _hoisted_2 = {
  ref: "header",
  class: "main-card-back-header"
}
const _hoisted_3 = { class: "number-time" }
const _hoisted_4 = { class: "line-route-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "plate-num"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "차량정보 : ", -1 /* HOISTED */))
const _hoisted_9 = { class: "bus-info" }
const _hoisted_10 = { class: "order" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_12 = {
  key: 1,
  class: "bus-stop-name"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "symbol" }, " → ", -1 /* HOISTED */))
const _hoisted_14 = {
  class: "content-area",
  ref: "contentArea"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "bus-number",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickLineInfo', $props.favoriteLine)))
        }, [
          _createVNode($setup["LineTypeChip"], {
            lineTypeCode: $props.favoriteLine.lineTypeCode,
            lineTypeName: $props.favoriteLine.lineTypeName
          }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.useGetLineRouteName(
                $props.favoriteLine.lineTypeCode,
                $props.favoriteLine.routeName,
                $props.favoriteLine.lineNum
              )), 1 /* TEXT */),
          _createVNode($setup["InlineSvg"], {
            class: "img-arrow",
            src: require('@/assets/icons/chevron-right.svg')
          }, null, 8 /* PROPS */, ["src"])
        ]),
        _createElementVNode("button", {
          ref: "refreshButton",
          class: "btn-refresh",
          onClick: $setup.updateBusLocation,
          "aria-label": "버스 위치 새로고침"
        }, [..._hoisted_6], 512 /* NEED_PATCH */)
      ]),
      ($setup.hasBusImage || $setup.hasBusPlateNumber)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", {
                onClick: $setup.toggleShowBusPlateNumbers,
                class: _normalizeClass(["plate", { underline: ($setup.busPlateNumbers?.length ?? 0) > 1 }])
              }, _toDisplayString($setup.busPlateNumberText), 3 /* TEXT, CLASS */),
              (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
                _createVNode($setup["Tooltip"], {
                  class: "tool-tip",
                  shouldShowTooltip: $setup.shouldShowBusPlateNumbers,
                  targetElement: $setup.tooltipTargetElement,
                  onOnClickCloseTooltip: $setup.closeBusPlateNumbersTooltip
                }, {
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.favoriteLine.buses, (busInfo) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: busInfo.allocUid
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(busInfo.busOrder), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(`${busInfo.carNo ?? " - "}${$setup.displayLastSeatCount(
                      busInfo.allocUid
                    )}`) + " ", 1 /* TEXT */),
                        _hoisted_11
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["shouldShowTooltip", "targetElement"])
              ]))
            ]),
            ($setup.hasBusImage)
              ? (_openBlock(), _createBlock($setup["InlineSvg"], {
                  key: 0,
                  class: "bus-image-icon",
                  src: require('@/assets/icons/picture.svg'),
                  alt: "차량 이미지 보기",
                  onClick: $setup.emitOnClickBusImage
                }, null, 8 /* PROPS */, ["src"]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString($props.favoriteLine.firstBusStop.name), 1 /* TEXT */),
            _hoisted_13,
            _createElementVNode("span", null, _toDisplayString($props.favoriteLine.lastBusStop.name), 1 /* TEXT */)
          ]))
    ], 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_14, [
      _createVNode($setup["BusStopList"], {
        busStops: $props.favoriteLine.busStops,
        lineId: $props.favoriteLine.lineId,
        turnId: $props.favoriteLine.turnId,
        busLocations: $setup.currentBusLocations,
        showInMainCard: true,
        isInsideShuttle: true,
        detourEndDtm: $props.favoriteLine.detourEndDtm,
        onOnClickScheduleBtn: $setup.emitOnClickScheduleBtn,
        onOnClickBusStopLocation: $setup.emitOnClickBusStopLocation
      }, null, 8 /* PROPS */, ["busStops", "lineId", "turnId", "busLocations", "detourEndDtm"])
    ], 512 /* NEED_PATCH */),
    _createCommentVNode(" <footer>\n      <div class=\"opacity-area\"></div>\n      <button class=\"btn-footer\" @click=\"$emit('showBusTimeTable')\">\n        시간표 보기\n      </button>\n    </footer> ")
  ]))
}